import { TextSmall } from '@/components/Texts';
import React from 'react';

const Severability = () => {
  return (
    <>
      <TextSmall fontWeight={700}>(8) Severability</TextSmall>
      <TextSmall>
        If any provision or part of these Terms, as amended periodically, is
        found to be invalid, void, or unenforceable, either wholly or partially,
        by any court of competent jurisdiction, such invalidity, voidness, or
        unenforceability applies only to that specific provision to the extent
        of its illegality, unenforceability, invalidity, or voidness, as
        applicable. The rest of these Privacy Policy remains fully effective and
        enforceable.
      </TextSmall>
    </>
  );
};

export default Severability;
